import React from 'react'

const WarningCircle = ({ size = 22, color = '#F96B06' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.75 0C16.6869 0 21.4998 4.8131 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0.000185863 4.8131 4.81305 0 10.75 0ZM10.75 1.5C5.64148 1.5 1.50019 5.64152 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C19.9998 5.64152 15.8585 1.5 10.75 1.5ZM10.7598 14C11.1739 14 11.5096 14.3359 11.5098 14.75C11.5098 15.1642 11.174 15.5 10.7598 15.5H10.75C10.3358 15.5 10 15.1642 10 14.75C10.0002 14.3359 10.3359 14 10.75 14H10.7598ZM10.75 6C11.1641 6 11.4998 6.33594 11.5 6.75V10.75C11.5 11.1642 11.1642 11.5 10.75 11.5C10.3358 11.5 10 11.1642 10 10.75V6.75C10.0002 6.33594 10.3359 6 10.75 6Z"
      fill={color}
    />
  </svg>
)

export default WarningCircle
